export default __webpack_public_path__ + "static/media/s-4.02b9bcad.jpg";